/**
 * Whether the analytics tracker is recording right now, as a module of its own so the app's
 * LootClient can read it without importing the tracker (which imports the client). While the
 * gate is open (the environment's mode allows sending and, under `consent_required`, the shopper
 * consented) every `/v1` call says so with `ANALYTICS_CONTEXT_HEADER`, and only then may the
 * server events that call causes record this browser's operating system, device and country.
 * Closed, the header is absent and those events carry none of it.
 */
import { ANALYTICS_CONTEXT_HEADER } from "@loot-os/api-contract";

let open = false;

/** Called by the tracker whenever its gate opens or closes. */
export function setAnalyticsGateOpen(next: boolean): void {
  open = next;
}

export function isAnalyticsGateOpen(): boolean {
  return open;
}

/** The `fetch` the app's LootClient is built with. */
export const fetchWithAnalyticsContext: typeof fetch = (input, init) => {
  if (!open) return fetch(input, init);
  const headers = new Headers(init?.headers);
  headers.set(ANALYTICS_CONTEXT_HEADER, "1");
  return fetch(input, { ...init, headers });
};
